import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { isCurrentLoginSession } from 'utils/loginSession'
import { useAppSelector } from 'hooks/redux-hooks'

const PrivateRoute = ({ children }) => {
  const { isLoggedIn, tokenHeader } = useAppSelector((state) => state.auth)
  const location = useLocation()
  const isNotificationRoute = location.pathname === '/notifications' || location.pathname.startsWith('/notification/lead/')

  return isLoggedIn && (!isNotificationRoute || isCurrentLoginSession(tokenHeader)) ? children :
    <Navigate to='/login' replace state={{ from: location.pathname + location.search }} />
  // return children
}

export default PrivateRoute
